// How much ambience a world gets (R479).
//
// FOG_COUNT, SNOW_COUNT and CREATURE_WHALES are tuned against the core world,
// and the scatter puts them over the whole rectangle. A 12x10 arcade board is
// about 1/164 of core's area, so the core count on it is a blanket and not a
// drift. Each count takes the world's area share, and the floor from
// presentation.toml keeps a light drift on the smallest board.
//
// All three read the live grid, so the caller must run them after `setGrid`.
// `WaterAmbience.resize()` does, which is what the arcade calls (R261), and
// `match.ts` builds the creature layer after `setGrid` for the same reason.
//
// The three counts sit in an engine-free leaf because the map layer and the
// menu preview ask the same question, and neither answer may drift from the
// other.

import {
  CREATURE_WHALES, FOG_COUNT, FOG_COUNT_MIN, SNOW_COUNT, SNOW_COUNT_MIN,
} from '../gen/presentation';
import { worldAreaShare } from '../world';

/** How many fog blobs this world gets (R479). */
export function fogCount(): number {
  return Math.max(FOG_COUNT_MIN, Math.round(FOG_COUNT * worldAreaShare()));
}

/** How many marine-snow grains this world gets (R479). */
export function snowCount(): number {
  return Math.max(SNOW_COUNT_MIN, Math.round(SNOW_COUNT * worldAreaShare()));
}

/**
 * How many whales this world gets (R479). A whale keeps its absolute sprite
 * scale on every map, so a small arcade board holds one whale: at that size a
 * whale is a visitor, and three of them are a blanket.
 */
export function whaleCount(): number {
  return Math.max(1, Math.round(CREATURE_WHALES * worldAreaShare()));
}
